export default "__VITE_ASSET__F3B05$ae__ 621w";